import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import SignupForm from "../components/signup-form.js";
export default {
    execute: async () => {
        const { form, submitBtn } = SignupForm.get();
        const payload = {
            email: form.email.value.trim().toLowerCase(),
            name: form.fullname.value.trim(),
            pass: form.password.value.trim()
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/register', payload);
        formRequest.afterResponse(true);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `You are successfully signed up.`,
                onRedirect: '/login'
            });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
